import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  computed,
  inject,
} from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { VexPopoverService } from '@vex/components/vex-popover/vex-popover.service';
import { SliceAuthService } from '../../../../core/autenticacao/slice-auth.service';
import { ToolbarUserDropdownComponent } from './toolbar-user-dropdown/toolbar-user-dropdown.component';

@Component({
    selector: 'vex-toolbar-user',
    templateUrl: './toolbar-user.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatRippleModule, MatIconModule]
})
export class ToolbarUserComponent {
  private popover = inject(VexPopoverService);
  private cd = inject(ChangeDetectorRef);
  private sliceAuthService = inject(SliceAuthService);
  private destroyRef = inject(DestroyRef);

  dropdownOpen: boolean = false;
  usuario = computed(() => this.sliceAuthService.usuarioLogado());

  showPopover(originRef: HTMLElement) {
    this.dropdownOpen = true;
    this.cd.markForCheck();

    const popoverRef = this.popover.open({
      content: ToolbarUserDropdownComponent,
      origin: originRef,
      offsetY: 12,
      position: [
        {
          originX: 'center',
          originY: 'top',
          overlayX: 'center',
          overlayY: 'bottom',
        },
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top',
        },
      ],
    });

    popoverRef.afterClosed$.subscribe(() => {
      this.dropdownOpen = false;
      this.cd.markForCheck();
    });
  }
}
